export default __webpack_public_path__ + "static/media/c_9.e5cdec85.svg";